// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"4f742fa0","229":"1bc9a4a5","376":"5aaab6e6","455":"b3cfbe0e","485":"1a0fc124","934":"a03ae252"}[chunkId] + ".chunk.js";
};